var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import React, { useMemo, useState } from 'react';
import { Button, InlineNotification, Table, Text } from '@ui';
import { saveEquipmentTypeMap } from '../shared/api';
import { translatorFor } from '../shared/i18n';
import { errorResponse } from '../shared/types';
import { buildMappingColumns } from './MappingCells';
import { NO_SUBTYPE, hasDuplicate, isComplete, toDraftRows, toMapRows } from './mappingDraft';
const t = translatorFor('equipment_mapping');
export function MappingEditor({ urls, catalog, catalogUnavailable, equipmentTypeMap, deviceTypeOptions, deviceSubtypeOptions, onSaved, onCancel }) {
    const [rows, setRows] = useState(() => toDraftRows(equipmentTypeMap));
    const [saving, setSaving] = useState(false);
    const [error, setError] = useState(null);
    const [nextKey, setNextKey] = useState(0);
    const catalogOptions = useMemo(() => (catalog !== null && catalog !== void 0 ? catalog : []).map((type) => ({ value: type.id, label: type.name })), [catalog]);
    const duplicate = hasDuplicate(rows);
    const invalid = rows.some((row) => !isComplete(row)) || duplicate;
    const locked = saving || catalog === null;
    const update = (key, patch) => setRows((previous) => previous.map((row) => (row.key === key ? Object.assign(Object.assign({}, row), patch) : row)));
    const columns = useMemo(() => buildMappingColumns({
        catalogOptions,
        deviceTypeOptions,
        deviceSubtypeOptions,
        disabled: locked,
        onChange: update,
        onRemove: (key) => setRows((previous) => previous.filter((entry) => entry.key !== key))
    }), 
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [catalogOptions, deviceTypeOptions, deviceSubtypeOptions, locked]);
    const addRow = () => {
        setRows((previous) => [
            ...previous,
            { key: `new-${nextKey}`, isNew: true, ipType: '', ipSubtype: NO_SUBTYPE, stId: '', stName: '' }
        ]);
        setNextKey((value) => value + 1);
    };
    const save = () => __awaiter(this, void 0, void 0, function* () {
        var _a, _b;
        setSaving(true);
        setError(null);
        try {
            onSaved(yield saveEquipmentTypeMap(urls, toMapRows(rows)));
        }
        catch (err) {
            setError((_b = (_a = errorResponse(err)) === null || _a === void 0 ? void 0 : _a.error) !== null && _b !== void 0 ? _b : t('save_failed'));
        }
        finally {
            setSaving(false);
        }
    });
    return (React.createElement("div", { className: "service-titan-settings__problem-body" },
        catalogUnavailable && React.createElement(InlineNotification, { variant: "warning" }, t('catalog_failed')),
        React.createElement(Table, { data: rows, columns: columns, getItemId: (row) => row.key, emptyContent: React.createElement(Text, { variant: "body" }, t('empty')), variant: "listing", size: "full" }),
        duplicate && React.createElement(InlineNotification, { variant: "warning" }, t('duplicate_row')),
        error && React.createElement(InlineNotification, { variant: "error" }, error),
        React.createElement("div", { className: "service-titan-settings__mapping-footer" },
            React.createElement(Button, { variant: "secondary", disabled: locked, onClick: addRow }, t('add_row')),
            React.createElement("div", { className: "service-titan-settings__actions" },
                React.createElement(Button, { variant: "secondary", disabled: saving, onClick: onCancel }, t('cancel')),
                React.createElement(Button, { variant: "primary", disabled: locked || invalid, onClick: () => {
                        void save();
                    } }, saving ? t('saving') : t('save'))))));
}
export default MappingEditor;
